import { render, staticRenderFns } from "./ListMappingResidents.vue?vue&type=template&id=56c622f9"
import script from "./ListMappingResidents.vue?vue&type=script&lang=js"
export * from "./ListMappingResidents.vue?vue&type=script&lang=js"
import style0 from "./ListMappingResidents.vue?vue&type=style&index=0&id=56c622f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports